export default __webpack_public_path__ + "static/media/nightmarecompanions.e1f45068.png";